import {
  InfiniteData,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { produce } from 'immer';

import { GET_AUDIENCES_QUERY_KEY } from './useGetAudiences';
import { GET_AUDIENCES_DEFAULT_QUERY_KEY } from './useGetAudiencesDefault';

import AudiencesService, {
  Audience,
  AudienceResponse,
} from '@/services/AudiencesService';

export function useAudienceGeneratePublicLink(audienceId: number) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: () => AudiencesService.generatePublicLink(audienceId),
    onSuccess: (data) => {
      if (data.opaqueId) {
        queryClient.setQueryData<Audience[]>(
          GET_AUDIENCES_DEFAULT_QUERY_KEY,
          produce((draft) => {
            if (draft) {
              const audience = draft.find((item) => item.id === audienceId);

              if (audience) {
                audience.opaqueId = data.opaqueId;
              }
            }
          }),
        );

        queryClient.setQueryData<InfiniteData<AudienceResponse>>(
          GET_AUDIENCES_QUERY_KEY,
          produce((draft) => {
            if (draft) {
              draft.pages.find((page) => {
                const audience = page.items.find(
                  (item) => item.id === audienceId,
                );

                if (audience) {
                  audience.opaqueId = data.opaqueId;
                }
              });
            }
          }),
        );
      }
    },
  });

  return {
    generatePublicLink: mutateAsync,
    isLoading: isPending,
  };
}
